import { useEffect, useState } from "react";
import { AlertTriangle, Loader2, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const DangerDialog = ({ open, onOpenChange, title, description, items, warning, onConfirm, children, confirmLabel = "Elimina definitivamente", irreversible = true }) => {
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setTxt(""); }, [open]);
  const go = async () => { setBusy(true); try { await onConfirm("ELIMINA"); } finally { setBusy(false); } };
  return (
    <Dialog open={open} onOpenChange={(o) => !busy && onOpenChange(o)}>
      <DialogContent className="max-w-lg rounded-2xl max-h-[92vh] overflow-y-auto core-scroll" data-testid="danger-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black text-[#C8102E] flex items-center gap-2"><AlertTriangle className="h-6 w-6" />{title}</DialogTitle>
          {description && <DialogDescription className="text-[#0A1128]">{description}</DialogDescription>}
        </DialogHeader>
        {items === null ? <div className="flex items-center gap-2 text-sm text-slate-600"><Loader2 className="h-4 w-4 animate-spin" />Calcolo dei dati coinvolti...</div> : (
          <div className="rounded-xl border border-red-200 bg-red-50/70 p-4" data-testid="danger-dialog-items">
            <div className="text-xs font-bold uppercase tracking-wider text-[#C8102E] mb-2">{irreversible ? "Verranno eliminati" : "Verranno spostati nel cestino"}</div>
            {items.length ? <ul className="space-y-1">{items.map((i) => (
              <li key={i.key} className="flex justify-between text-sm text-[#0A1128]" data-testid={`danger-item-${i.key}`}><span>{i.label}</span><span className="font-bold">{i.count}</span></li>
            ))}</ul> : <div className="text-sm text-slate-600">Nessun dato da eliminare.</div>}
          </div>
        )}
        {warning && <div className="rounded-xl bg-amber-50 border border-amber-200 p-3 text-sm font-semibold text-amber-800" data-testid="danger-dialog-warning">{warning}</div>}
        {children}
        <div>
          <div className="text-sm text-[#0A1128] mb-1.5">{irreversible ? <>L'operazione è <strong>irreversibile</strong>.</> : <>Potrai ripristinare tutto dal <strong>Cestino</strong> entro 7 giorni, poi verrà eliminato definitivamente.</>} Per confermare digita <strong>ELIMINA</strong>:</div>
          <Input value={txt} onChange={(e) => setTxt(e.target.value)} placeholder="ELIMINA" className="rounded-xl font-bold tracking-widest" data-testid="danger-dialog-input" />
        </div>
        <DialogFooter>
          <Button variant="ghost" className="rounded-full" disabled={busy} onClick={() => onOpenChange(false)} data-testid="danger-dialog-cancel">Annulla</Button>
          <Button disabled={txt.trim() !== "ELIMINA" || busy || items === null} onClick={go} className="rounded-full bg-[#C8102E] hover:bg-[#A50D26] font-bold" data-testid="danger-dialog-confirm">
            {busy ? <Loader2 className="h-4 w-4 animate-spin mr-1.5" /> : <Trash2 className="h-4 w-4 mr-1.5" />}{confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
